/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module DriverupdaterecommendationTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface DriverUpdateRecommendationRequest {
    [k: string]: any;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverUpdateRecommendation".
 */
export interface DriverUpdateRecommendation {
    /**
     * Human-readable update name
     */
    name: string;
    /**
     * Update version in XXX.YY format
     */
    version: string;
    /**
     * Release date/time in ISO 8601 format
     */
    releaseDateTime: string;
    /**
     * URL to download installer from
     */
    downloadURL: string;
    driverType: DriverTypeEnum;
}
/**
 * Driver metadata retained by the NVIDIA App UI for the current and previously installed drivers.
 *
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverInstallHistoryEntry".
 */
export interface DriverInstallHistoryEntry {
    name: string;
    version: string;
    releaseDateTime: string;
    downloadURL: string;
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GPUInfo".
 */
export interface GPUInfo {
    GPU: {
        LongGPUName: string;
        ShortGPUName: string;
        ActualVRAMSize: string;
        GPURAMType: string;
        IsQuadro: string;
        DeviceId: string;
        VendorId: string;
        SubSystemId: string;
        SubVendorId: string;
        GPUArchitecture: string;
        GPUArchImplementation?: string;
        IsPrimary: string;
        TensorCores?: string;
        GpuHandle: string;
        SKUMod?: string;
        Tgp: string;
    }[];
    SLI: SLI;
    IsOptimus: string;
}
export interface SLI {
    SLISupported: string;
    HasActiveSLITopology: string;
    ActiveTopologyGPUCount: string;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GenericInfo".
 */
export interface GenericInfo {
    PhysicalMemoryCapacity: string;
    TotalPhysicalMemory: string;
    CurrentResolution: string;
    DriverVersion: string;
    DriverType?: DriverTypeEnum;
    IsDCHDriverInstalled: string;
    MoboType: string;
    MinimumDriverVersion: string;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "LanguagePreference".
 */
export interface LanguagePreference {
    languageCode?: string;
    isSaved?: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetDriverUpdateRecommendationReturn".
 */
export interface GetDriverUpdateRecommendationReturn {
    result?: DriverUpdateRecommendation;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetDriverInstallHistoryParameters".
 */
export interface SetDriverInstallHistoryParameters {
    drivers: DriverInstallHistoryEntry[];
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetDriverInstallHistoryReturn".
 */
export interface GetDriverInstallHistoryReturn {
    drivers: DriverInstallHistoryEntry[];
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetUserDriverTypePreferenceReturn".
 */
export interface GetUserDriverTypePreferenceReturn {
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetUserDriverTypePreferenceParameters".
 */
export interface SetUserDriverTypePreferenceParameters {
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetUpdateStrategyPreferenceReturn".
 */
export interface GetUpdateStrategyPreferenceReturn {
    updateStrategy: UpdateStrategyEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetUpdateStrategyPreferenceParameters".
 */
export interface SetUpdateStrategyPreferenceParameters {
    updateStrategy: UpdateStrategyEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetAutomaticDriverDownloadEnabledReturn".
 */
export interface GetAutomaticDriverDownloadEnabledReturn {
    /**
     * true if automatic driver update download is enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetAutomaticDriverDownloadEnabledParameters".
 */
export interface SetAutomaticDriverDownloadEnabledParameters {
    /**
     * Enable or disable automatic driver update download
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "RegisterDriverUpdateCheckProgressNotificationsReturn".
 */
export interface RegisterDriverUpdateCheckProgressNotificationsReturn {
    status: DriverUpdateCheckProgress;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetGRDEditorPreviewModeReturn".
 */
export interface GetGRDEditorPreviewModeReturn {
    /**
     * true if GRD editor preview mode is enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetDriverUpdateNotificationEnabledReturn".
 */
export interface GetDriverUpdateNotificationEnabledReturn {
    /**
     * true if driver update desktop notifications are enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetDriverUpdateNotificationEnabledParameters".
 */
export interface SetDriverUpdateNotificationEnabledParameters {
    /**
     * Enable or disable driver update desktop notifications
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetRewardsNotificationPreferenceReturn".
 */
export interface GetRewardsNotificationPreferenceReturn {
    /**
     * true if rewards notification is enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetRewardsNotificationPreferenceParameters".
 */
export interface SetRewardsNotificationPreferenceParameters {
    /**
     * Enable or disable rewards notification
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetLanguagePreferenceReturn".
 */
export interface GetLanguagePreferenceReturn {
    languagePreference: LanguagePreference;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetLanguagePreferenceParameters".
 */
export interface SetLanguagePreferenceParameters {
    languageCode: string;
}

/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverTypeEnum".
 */
export enum DriverTypeEnum {
    GameReadyDriver = 0,
    CreatorReadyDriver = 1
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "UpdateStrategyEnum".
 */
export enum UpdateStrategyEnum {
    WsRecommendedDriver = 2,
    WsLeadingEdgeDriver = 3,
    WsConservativeDriver = 4
}
/**
 * Defines current state of driver update check
 *
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverUpdateCheckProgress".
 */
export enum DriverUpdateCheckProgress {
    started = 'started',
    finished = 'finished',
    failed = 'failed',
    cancelled = 'cancelled'
}


}
